import styled from 'styled-components'
import { DefaultFontStyle } from '../../styles/global-styles'

export const LoginPageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: ${props => props.theme.colours.white};
  position: absolute;
  overflow: hidden;
`

export const PageContent = styled.span`
  position: relative;
  bottom: 20px;
  padding: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: ${props => props.theme.colours.white};

  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    bottom: 60px;
  }

  @media (max-height: ${props => props.theme.breakpoints.lg}px) {
    bottom: 0;
  }
`

export const LoginPageImage = styled.img`
  width: 100%;
  max-width: 800px;
  position: relative;

  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    max-width: 800px;
  }

  @media (min-width: ${props => props.theme.breakpoints.xl}px) {
    max-width: 900px;
  }

  @media (min-width: ${props => props.theme.breakpoints.md}px) and (max-height: ${props =>
      props.theme.breakpoints.md}px) {
    max-width: 250px;
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}px) and (max-height: ${props =>
      props.theme.breakpoints.md}px) {
    max-width: 550px;
  }

  @media (min-width: ${props => props.theme.breakpoints.xl}px) and (max-height: ${props =>
      props.theme.breakpoints.lg}px) {
    max-width: 650px;
  }

  @media (max-height: ${props => props.theme.breakpoints.xs}px) {
    display: none;
  }
`

export const LoginFormTitle = styled.h1`
  ${DefaultFontStyle};
  font-weight: 500;
  font-size: 24px;
  margin-top: 0;

  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    font-size: 40px;
    line-height: 38px;
  }

  @media (max-height: ${props => props.theme.breakpoints.md}px) {
    font-size: 28px;
  }
`
export const LoginFormText = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  font-family: 'Roboto';
  margin: 0;
  margin-bottom: 55px;
  max-width: 45ch;

  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    font-size: 18px;
    width: 30ch;
  }

  @media (max-height: ${props => props.theme.breakpoints.md}px) {
    font-size: 16px;
    margin-bottom: 15px;
  }
`

export const GoogleIcon = styled.img`
  width: 24px;
  height: 24px;
`

export const TopCircle = styled.div`
  position: absolute;
  height: 140px;
  width: 140px;
  border-radius: 100%;
  top: -60px;
  right: -60px;
  z-index: -1;
  background: ${props => props.theme.colours.yellow};

  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    height: 240px;
    width: 240px;
    top: -90px;
    right: -90px;
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    height: 340px;
    width: 340px;
    top: -140px;
    right: -140px;
  }
`

export const LeftCircle = styled.div`
  position: absolute;
  height: 100px;
  width: 100px;
  border-radius: 100%;
  left: -75px;
  top: 40vh;
  z-index: -1;
  background: ${props => props.theme.colours.yellow};

  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    height: 200px;
    width: 200px;
    left: -140px;
    top: 40vh;
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    height: 300px;
    width: 300px;
  }
`

export const BottomCircle = styled.div`
  position: absolute;
  height: 160px;
  width: 160px;
  border-radius: 100%;
  bottom: -110px;
  right: 15vw;
  z-index: -1;
  background: ${props => props.theme.colours.yellow};

  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    height: 200px;
    width: 200px;
    bottom: -110px;
    right: 15vw;
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    height: 300px;
    width: 300px;
    bottom: -160px;
  }

  @media (min-width: ${props => props.theme.breakpoints.xl}px) {
    right: 25vw;
  }
`
